import { Component } from '@angular/core';


export class SkyVerticalTabsDemoComponent {
  public groups: any[];

  constructor() {
    this.groups = [
      {
        heading: 'Group 1',
        isOpen: false,
        isDisabled: false,
        subTabs: [
          { tabHeading: 'Group 1 — Tab 1', content: 'Group 1 — Tab 1 Content'},
          { tabHeading: 'Group 1 — Tab 2', content: 'Group 1 — Tab 2 Content', tabHeaderCount: 7}]
      },
      {
        heading: 'Group 2',
        isOpen: true,
        isDisabled: false,
        subTabs: [
          { tabHeading: 'Group 2 — Tab 1', content: 'Group 2 — Tab 1 Content', active: true},
          { tabHeading: 'Group 2 — Tab 2 — Disabled',
            content: 'Group 2 — Tab 2 Content',
            disabled: true
          }]
      },
      {
        heading: 'Disabled',
        isOpen: false,
        isDisabled: true,
        subTabs: []
      }
    ];
  }

  public tabChanged(newIndex: any) {
    console.log(`new active ${newIndex}`);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-vertical-tabs-demo',
  template: `<div style="height: 40vh">
  <sky-vertical-tabset
    showTabsText="Tab list"
    (activeChange)="tabChanged($event)">

    <sky-vertical-tabset-group
      *ngFor="let group of groups"
      [groupHeading]="group.heading"
      [open]="group.isOpen"
      [disabled]="group.isDisabled">

      <sky-vertical-tab
        *ngFor="let tab of group.subTabs"
        [active]="tab.active"
        [tabHeading]="tab.tabHeading"
        [tabHeaderCount]="tab.tabHeaderCount"
        [disabled]="tab.disabled">
        {{ tab.content }}
      </sky-vertical-tab>
    </sky-vertical-tabset-group>
  </sky-vertical-tabset>
</div>

<h3>
  Without groups
</h3>

<sky-vertical-tabset (activeChange)="tabChanged($event)">
  <sky-vertical-tab tabHeading="tab 1">
    Tab 1 content
  </sky-vertical-tab>
  <sky-vertical-tab tabHeading="tab 2" active="true">
    Tab 2 content
  </sky-vertical-tab>
  <sky-vertical-tab tabHeading="tab 3">
    Tab 3 content
  </sky-vertical-tab>
</sky-vertical-tabset>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
